import React from 'react';
import { Link } from 'react-router-dom';
import './PlanSite.css';

const PlanSite = () => {
  return (
    <div className="PlanSite">
      <div className="PlanSite__title">Plan du site</div>
      <ul className="PlanSite__list">
        <li className="PlanSite__link">
          <Link to="/">Accueil</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/nos-pharmacies-expertes">Nos pharmacies expertes</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/nos-partenaires">Nos partenaires</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/nos-atouts">Nos atouts</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/nos-news">Nos news</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/nous-rejoindre">Envie de nous rejoindre ?</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/cgu">CGU et mentions légales</Link>
        </li>
        <li className="PlanSite__link">
          <Link to="/plan-du-site">Plan du site</Link>
        </li>
      </ul>
    </div>
  );
};

export default PlanSite;
